.ec{border:1px solid #ddd;}